// extracted by mini-css-extract-plugin
export default {"cls1":"AdminBarActivator-cls1_ZeY","cls2":"AdminBarActivator-cls2_ZMH AdminBarActivator-cls1_ZeY"};